import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IMAGES from '../../../utils/imagesProvider'
import { H2 } from '../../typography'
import { WEBLINK, APP_STORE, GOOGLE_PLAY } from '../../../constants/names'
import './style.css'

const PublicLink = (props) => {
  let iconSrc
  const { linkName, linkTo } = props
  if (linkName === WEBLINK) iconSrc = IMAGES.icon_project_weblink
  if (linkName === APP_STORE) iconSrc = IMAGES.icon_project_appstore
  if (linkName === GOOGLE_PLAY) iconSrc = IMAGES.icon_project_google_play

  return (
    <div className='public-link-wrapper'>
      <a href={linkTo} rel='noopener noreferrer' target='_blank' className='public-link'>
        <img src={iconSrc} alt={`project link to ${linkName}`} className='public-link__img' />
        <span className='public-link__name'>{linkName}</span>
      </a>
    </div>
  )
}

PublicLink.propTypes = {
  linkName: PropTypes.string,
  linkTo: PropTypes.string
}

class ProjectSlide extends Component {
  static propTypes = {
    project: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      year: PropTypes.number,
      tags: PropTypes.arrayOf(PropTypes.string),
      services: PropTypes.arrayOf(PropTypes.string),
      description: PropTypes.string,
      publicLinks: PropTypes.arrayOf(PropTypes.shape({
        linkName: PropTypes.string,
        linkTo: PropTypes.string
      }))
    }),
    projectIndex: PropTypes.number,
    style: PropTypes.shape({})
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    const { projectIndex } = this.props
    if (prevProps.projectIndex !== projectIndex) {
      this.projectSlider && this.projectSlider.swiper.slideToLoop(projectIndex)
    }
  }

  render () {
    const { project, style, className } = this.props
    return (
      <div style={style} className={className}>
        <div key={project.id} className='projects_project-card__content'>
          <div className='projects_project-card__content-details'>
            <div className='header'>
              <div className='year'>&#8216;{project.year && String(project.year).slice(-2)}</div>
              <H2 className='name'>{project.name || ''}</H2>
            </div>
            <div className='tags'>{project && project.tags && project.tags.map(tag => (<div key={tag}>{tag}</div>))}</div>
            <div className='description'>{project.description}</div>
          </div>
          <div className='btn-links'>
            <div className='public-link__block'>
              {
                project.publicLinks
                  ? project.publicLinks.map(link => (<PublicLink key={link.linkName} {...link} />))
                  : ''
              }
            </div>
          </div>
          <div className='services'>
            <div className='services-title'>Services</div>
            <div className='services-content'>
              {project && project.services && project.services.map(s => (<div className='services-content__item' key={s}>{s}</div>))}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProjectSlide
